import { Guid as _guid } from './guid';

export namespace Random {
    export import Guid = _guid;
}